export const CONNECTION_STATUS = {
    CONNECTED: "CONNECTED",
    DISCONNECTED: "DISCONNECTED",
};

export const SUBSCRIPTION_STATUS = {
  PLAN_SELECTED: "PLAN_SELECTED",
  PENDING: "PENDING",
  AUTH_COMPLETE: "AUTH_COMPLETE",
  ACTIVE: "ACTIVE",
  CANCELLATION_PENDING: "CANCELLATION_PENDING",
  CANCELLED: "CANCELLED",
};
